import { render, staticRenderFns } from "./PostAssemble.vue?vue&type=template&id=dfa71232&scoped=true"
import script from "./PostAssemble.vue?vue&type=script&lang=js"
export * from "./PostAssemble.vue?vue&type=script&lang=js"
import style0 from "./PostAssemble.vue?vue&type=style&index=0&id=dfa71232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa71232",
  null
  
)

export default component.exports